import * as Yup from 'yup';
import { PurchaseRawData, PurchaseInputData } from '../models/purchase.ts';

export type CheckoutDto = PurchaseInputData & {
    purchaseId?: string,
    referral?: string,
};

// deno-lint-ignore no-namespace
export namespace CheckoutDto {
    export function createValidation(): Yup.ObjectSchema<CheckoutDto> {
        return Yup.object({
            productSlug: Yup.string().required('Product is required'),
            assetType: Yup.string().required('Type is required').oneOf(PurchaseInputData.ValidTypes, 'Invalid type'),
            email: Yup.string().email("It's not a valid email").required('Email is required'),
            username : Yup.string().required('User name is required'),
            phone: Yup.string().required('Phone number is required'),
            authorName : Yup.string().required('Artist name is required'),
            assetName: Yup.string().required('Song name is required'),
            assetLink: Yup.string().optional().url('Song link is invalid'),
            releaseDate: Yup.string().nullable().optional(),
            notes: Yup.string().optional(),
            promocode: Yup.string().nullable().optional(),
            purchaseId: Yup.string().optional(),
            referral: Yup.string().optional(),
        }).noUnknown();
    }
}

export type CheckoutResponseDto = {
    purchase: PurchaseRawData;
};
